<template>
  <div class="info-box">
    <el-form
      :model="state.model"
      label-width="auto"
      label-position="top"
      ref="formDom"
      size="large"
      class="flex-1 overflow-y-auto px-2.5"
    >
      <el-form-item
        label="名称"
        prop="name"
        :rules="[{ required: true, message: '请输入名称', trigger: 'blur' }]"
      >
        <el-input v-model="state.model.name"></el-input>
      </el-form-item>
      <el-form-item
        label="可住人数"
        prop="num"
        :rules="[
          { required: true, message: '请输入可住人数', trigger: 'blur' },
        ]"
      >
        <el-input-number
          v-model="state.model.num"
          precision="0"
          :max="10"
          class="number-input-left number-input-suffix"
          suffix="人"
        ></el-input-number>
      </el-form-item>
      <el-form-item
        label="单价"
        prop="price"
        :rules="[{ required: true, message: '请输入单价', trigger: 'blur' }]"
      >
        <el-input-number
          v-model="state.model.price"
          precision="2"
          class="number-input-left number-input-suffix"
          suffix="元"
        ></el-input-number>
      </el-form-item>
    </el-form>
    <div class="submit-box px-2.5">
      <el-button type="primary" size="large" @click="onSubmit">
        提交
      </el-button>
    </div>
  </div>
</template>

<script>
import { onMounted, reactive, ref } from "vue";

export default {
  props: {
    model: Object,
  },
  setup(props, { emit }) {
    props: {
    }
    const formDom = ref(null);
    const state = reactive({
      model: {
        name: "大床房",
        num: 2,
        price: 100,
      },
    });
    onMounted(() => {
      if (props.model?.name) state.model = props.model;
    });

    const onSubmit = () => {
      formDom.value.validate((valid) => {
        if (valid) {
          emit("confirm", state.model);
        }
      });
    };

    return {
      state,
      props,
      formDom,
      onSubmit,
    };
  },
};
</script>
<style scoped></style>
